import React from "react";
import PropTypes from "prop-types";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import ErrorRecordTable from "../../../../utils/ErrorRecordTable";

function ErrorRecords({ data, loading = false, handleBackclick }) {
  const { FILE_NAME = "", errorRecords = [] } = data;

  return (
    <Grid container spacing={2}>
      <Grid sx={{ display: "flex", alignItems: "center" }} size={12}>
        <IconButton onClick={handleBackclick} disabled={loading}>
          <ArrowBackIcon />
        </IconButton>
        {!loading ? (
          <Box sx={{ marginLeft: "auto" }}>
            <span style={{ fontWeight: "bolder" }}>File Location - </span>
            {FILE_NAME}
          </Box>
        ) : (
          <></>
        )}
      </Grid>
      <Grid size={12}>
        <Paper elevation={2} sx={{ maxWidth: "100%" }}>
          <ErrorRecordTable data={errorRecords} tableMaxHeight="550px" loading={loading} />
        </Paper>
      </Grid>
    </Grid>
  );
}

ErrorRecords.propTypes = {
  data: PropTypes.array.isRequired,
  handleBackclick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ErrorRecords;
